export default async () => {
	/*-------- Modals --------*/
	const { default: Overlay } = await import('@components/overlays')

	document.querySelectorAll('.modal').forEach(item => new Overlay(item))

	/*-------- Menu --------*/
	const menuWrapper = document.querySelector('.menu-wrapper')
	const menuToggle = document.querySelector('.menu-toggle')

	if (menuWrapper && menuToggle) {
		const { default: Menu } = await import('@components/menu')

		new Menu(menuWrapper, menuToggle)
	}

	$(document).ready(function() {
		var positions = []; // Stocke les positions des éléments
	
		// Initialiser les positions des éléments
		$('.block-listcard .elem').each(function(index) {
			positions[index] = $(this)[0].getBoundingClientRect().top;
		});
	
		$(window).on('scroll', function() {
			$('.block-listcard .elem').each(function(index) {
				var elem = $(this);
				var opaElem = elem.find('.opa');
				var btnElem = elem.find('.text .btn');
				var currentTop = elem[0].getBoundingClientRect().top;
	
				// Vérifier si la position du haut de l'élément a changé
				if (currentTop !== positions[index]) {
					// L'élément est en mouvement
					opaElem.css('opacity', 0);
					btnElem.css('opacity', 1);
					positions[index] = currentTop; // Mettre à jour la position
				} else {
					// L'élément a cessé de bouger - augmenter progressivement l'opacité
					var elemHeight = $(window).height(); // Hauteur de la fenêtre
					var distanceScrolled = Math.min(elemHeight, Math.abs(currentTop)); // Distance parcourue pour augmenter l'opacité
					var opacity = Math.min(0.5, distanceScrolled / (elemHeight / 2)); // Opacité allant progressivement de 0 à 0.5
	
					opaElem.css('opacity', opacity);
					btnElem.css('opacity', 0.5);
				}
			});
		});
	});
	
	
	
	


}